// @flow

const TOKEN_DATA_UPDATE = "token/data/set";
const TOKEN_DATA_ERROR = "token/data/error";

export default {
    TOKEN_DATA_UPDATE,
    TOKEN_DATA_ERROR,
};


// WEBPACK FOOTER //
// ./src/Store/Ducks/TokenData/types.js